import React from "react";
import PropTypes from "prop-types";
import Icon from "../icon/icon";
import Button from "../button/button";
import { gatherClasses, isObject, hasProperty } from "../../lib/utils";

const iconSizes = {
  lg: 48,
  md: 32
};

const RegularMessageBox = ({
  size,
  icon,
  primaryText,
  secondaryText,
  action,
  isHtml
}) => {
  let iconWidth = iconSizes[size];
  let iconHeight = iconSizes[size];

  if (hasProperty(icon, "width")) {
    iconWidth = parseInt(icon.width, 10);
    iconHeight = hasProperty(icon, "height")
      ? parseInt(icon.height, 10)
      : iconWidth;
  } else if (React.isValidElement(icon) && hasProperty(icon.props, "width")) {
    iconWidth = parseInt(icon.props.width, 10);
    iconHeight = hasProperty(icon.props, "height")
      ? parseInt(icon.props.height, 10)
      : iconWidth;
  }

  const iconClass = gatherClasses(
    null,
    "oui-mbx-icon",
    `oui-icon-${size}`,
    icon.className || ""
  );
  return (
    <div className={gatherClasses(null, "oui-mbx-regular", `oui-mbx-${size}`)}>
      {icon ? (
        React.isValidElement(icon) ? (
          React.cloneElement(icon, {
            className: gatherClasses(
              null,
              "oui-mbx-icon",
              icon.props.className
            ),
            width: iconWidth,
            height: iconHeight
          })
        ) : (
          <Icon
            className={iconClass}
            {...icon}
            width={`${iconWidth}px`}
            height={`${iconHeight}px`}
          />
        )
      ) : null}

      {primaryText && <div className="oui-mbx-text-primary">{primaryText}</div>}

      {secondaryText && (
        <div
          className={gatherClasses(
            null,
            "oui-mbx-text-secondary",
            !primaryText ? "oui-no-primary" : ""
          )}
        >
          {isHtml ? (
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{ __html: secondaryText }} />
          ) : (
            secondaryText
          )}
        </div>
      )}

      {/* TODO: In future we would put this null check in function itself */}
      {isObject(action) && action !== null && (
        <div className="oui-mbx-message-action">
          <Button
            size="sm"
            type={action.type === "link" ? "link" : "secondary"}
            label={action.data && action.data.label}
            onClick={action.data && action.data.onClick}
            href={action.data && action.data.href}
            disabled={action.data.disabled}
          />
        </div>
      )}
    </div>
  );
};

RegularMessageBox.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  size: "md",
  primaryText: "",
  secondaryText: ""
};

RegularMessageBox.propTypes = {
  size: PropTypes.oneOf(["lg", "md"]).isRequired,
  icon: PropTypes.shape(Icon.propTypes).isRequired,
  primaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  secondary: PropTypes.string,
  className: PropTypes.string,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["button", "link"]).isRequired,
    data: PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
      onClick: PropTypes.func,
      disabled: PropTypes.bool
    })
  }),
  isHtml: PropTypes.bool
};

RegularMessageBox.displayName = "OrionMessageBoxRegular";

export default RegularMessageBox;
